"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleCustomError = void 0;
// Classes
const error_1 = __importDefault(require("./error"));
exports.SimpleCustomError = error_1.default;
// Middleware
const apiError_1 = __importDefault(require("./middleware/apiError"));
class SimpleCustomErrors {
    static createError(type, subErrors) {
        // Check if name is given
        if (!type) {
            throw new error_1.default('Error type undefined');
        }
        // Check if name already exists
        if (typeof SimpleCustomErrors.Errors[type] !== typeof undefined) {
            throw new error_1.default(`Error '${type}' already exists`);
        }
        // Add error to Errors object
        class UndefinedError extends error_1.default {
            constructor(code, params, options) {
                super(code, params);
                // Set type
                this.type = type;
                // Set stack, if given
                if (options === null || options === void 0 ? void 0 : options.stack) {
                    this.stack = options.stack;
                }
            }
            configureError(params) {
                var _a, _b;
                const subError = (_b = (_a = SimpleCustomErrors.Errors[type]) === null || _a === void 0 ? void 0 : _a.subErrors) === null || _b === void 0 ? void 0 : _b.find((error) => error.code === this.code);
                if (!subError) {
                    return this;
                }
                // Set params
                if (subError.params && Array.isArray(subError.params)) {
                    subError.params.forEach((key) => {
                        // Create params if they don't exist
                        if (!this.params) {
                            this.params = {};
                        }
                        // Set params to given key or null
                        this.params[key] = (params && params[key] ? params[key] : null);
                    });
                }
                // Set description
                this.message = (subError.description || this.message);
                // Set HTTP code
                this.http = (subError.http || this.http);
                // Set sentry
                this.sentry = (typeof subError.sentry !== typeof undefined ? subError.sentry : this.sentry);
                // Convert variables in message to keys
                Object.keys(this.params || []).forEach((key) => {
                    this.message = this.message.replace(new RegExp(`{{${key}}}`, 'g'), (this.params && this.params[key] ? this.params[key] : undefined));
                });
                return this;
            }
        }
        // Add sub-errors
        SimpleCustomErrors.Errors[type] = UndefinedError;
        SimpleCustomErrors.Errors[type].subErrors = subErrors;
        // Give the error the right name
        Object.defineProperty(SimpleCustomErrors.Errors[type], 'name', { value: type });
        SimpleCustomErrors.Errors[type].prototype.name = type;
        return SimpleCustomErrors.Errors[type];
    }
}
exports.default = SimpleCustomErrors;
SimpleCustomErrors.Error = error_1.default;
SimpleCustomErrors.Errors = {};
SimpleCustomErrors.Middleware = {
    apiError: apiError_1.default
};
